import React from 'react';
import { Send } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

const RosterSummary = ({ services, canManage, publishing, onPublish }) => {
  const draftCount = services.filter((service) => service.status === 'concept').length;
  const publishedCount = services.length - draftCount;

  return (
    <section className="flex flex-wrap items-center justify-between gap-4 border-y border-slate-200 py-3" aria-label="Samenvatting maandrooster">
      <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-sm">
        <span className="font-semibold text-slate-900">{services.length} {services.length === 1 ? 'dienst' : 'diensten'}</span>
        <span className={draftCount ? 'font-medium text-amber-700' : 'text-slate-500'}>{draftCount} nog concept</span>
        <span className="text-slate-500">{publishedCount} gepubliceerd</span>
        {!draftCount && services.length > 0 && <Badge variant="outline" className="font-normal text-emerald-700">Rooster gepubliceerd</Badge>}
      </div>
      {canManage && (
        <Button
          type="button"
          variant={draftCount ? 'default' : 'outline'}
          onClick={onPublish}
          disabled={publishing || !services.length}
          className={draftCount ? 'bg-teal-600 text-white hover:bg-teal-700' : 'text-slate-600'}
        >
          <Send className="mr-2 h-4 w-4" />
          {publishing ? 'Publiceren...' : 'Publiceer & verstuur rooster'}
        </Button>
      )}
    </section>
  );
};

export default RosterSummary;

